import { Flex } from '@chakra-ui/react';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceProductItem } from 'model/modules/services/serviceProductItem';
import { take } from 'lodash';
import AppRoute from 'router/AppRoute';
import ServiceProductGridItem from './ServiceProductGridItem';

interface Props {
  products: ServiceProductItem[];
  title?: string | null;
}

const ProductsShortGrid: FC<Props> = ({ products, title }) => {
  const { t } = useTranslation();
  const gapBetweenCards = 16;

  if (products.length === 0) {
    return null;
  }

  return (
    <>
      <GridHeading
        trailingLink={{
          text: t('allItems'),
          path: AppRoute.serviceProducts,
        }}
      >
        {title ?? t('productsTitle')}
      </GridHeading>
      <Flex w="100%">
        {take(products, 3).map((product, index) => (
          <ServiceProductGridItem
            key={product.id}
            product={product}
            mr={(index + 1) % 3 === 0 ? '0' : `${gapBetweenCards}px`}
            w={`calc(100% / 3 - ${gapBetweenCards / 2}px)`}
          />
        ))}
      </Flex>
    </>
  );
};

export default ProductsShortGrid;
